import type { FC } from 'react';
import { translate } from '@/domains/core/localization/translate';
import { Link } from '@/domains/core/routing/components/Link';
import { trackSeeDetailsClick } from '@/domains/productDiscovery/ProductPage/b2c/modules/Header/SeeProductDetail/tracking';
import styles from './SeeProductDetail.module.scss';
export const {
  seeProductDetails
} = translate({
  "seeProductDetails": "See product details"
});
export const SeeProductDetail: FC = () => <Link className={styles.linkStyles} href="#description" scroll={false} onClick={trackSeeDetailsClick} shallow>
    {seeProductDetails}
  </Link>;